import { createFormHook } from '@tanstack/react-form'

import { FileField } from '@/components/forms/FileField'
import {
  GuestSelectField,
  MasterGuestSelectField,
} from '@/components/forms/MasterGuestSelectField'
import { RadioField } from '@/components/forms/RadioField'
import { SelectField } from '@/components/forms/SelectField'
import { SubmitButton } from '@/components/forms/SubmitButton'
import { TextareaField } from '@/components/forms/TextareaField'
import { TextField } from '@/components/forms/TextField'

import { fieldContext, formContext } from './context'

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    SelectField,
    RadioField,
    TextareaField,
    FileField,
    GuestSelectField,
    MasterGuestSelectField,
  },
  formComponents: {
    SubmitButton,
  },
})
